import { render, staticRenderFns } from "./choosePassenger.vue?vue&type=template&id=8270cf5c&"
import script from "./choosePassenger.vue?vue&type=script&lang=js&"
export * from "./choosePassenger.vue?vue&type=script&lang=js&"
import style0 from "./choosePassenger.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports